import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import NumberInput from 'shared/components/NumberInput/NumberInput';
import Slider from 'shared/components/AntdComponents/Slider/Slider';

import s from './NumberInputWithSlider.css';

class NumberInputWithSlider extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onInputBlur: PropTypes.func.isRequired,
    onSliderChange: PropTypes.func.isRequired,
  };
  static defaultProps = {
    title: '',
  };

  render() {
    const {
      name,
      title,
      min,
      max,
      value,
      onSliderChange,
      onInputChange,
      onInputBlur,
      ...otherAttrs
    } = this.props;

    return (
      <div {...otherAttrs}>
        {title && (
          <div className={`mrb-9 ${s.title}`}>
            <FormattedMessage id={title} />
          </div>
        )}
        <NumberInput
          className={s.input}
          onChange={val => onInputChange(name, val)}
          value={value}
          onBlur={val => onInputBlur(name, Number((val.target.value || '').replace(/\s*/g, '')))}
        />

        <Slider
          min={min}
          max={max}
          onChange={val => onSliderChange(name, val)}
          className={s.slider}
          value={value}
          trackStyle={{ backgroundColor: '#FFC107' }}
          handleStyle={{
            borderColor: '#FFC107',
            backgroundColor: '#FFFFFF',
            boxShadow: 'rgb(0 0 0 / 25%) 0px 1px 6px',
          }}
          defaultValue={0}
        />
      </div>
    );
  }
}

export default withStyles(s)(NumberInputWithSlider);



// WEBPACK FOOTER //
// ./src/shared/components/UI/NumberInputWithSlider/NumberInputWithSlider.js